<aside id="sidebar-wrapper"
  [class]="{'left-bar': !navbarGroup.length, 'left-bar-knowledge': navbarGroup.length, 'sidebar-wrapper-dev-bg':environment.name === 'development' || environment.name === 'local', 'sidebar-wrapper-front-bg':environment.name === 'staging'}">
  <div (click)="navigateToHomePage()" class="sidebar-brand sidebar-brand-big">
    <img src="assets/images/white-sky-net.svg" width="200" />
  </div>

  <div (click)="navigateToHomePage()" class="sidebar-brand sidebar-brand-small">
    <img src="assets/images/skynet-symbol.png" style="width: 32px; margin-left: 19px" />
  </div>

  <span (click)="navigateToVersionPage()" class="version" [ngClass]="{ 'badge': version.name }">
    v{{ appVersion }}
  </span>

  <ul class="leftbar-nav">
    <ng-container *ngFor="let group of groups; let i = index">
      <li *ngIf="group.visible" [ngClass]="{ 'is-expanded': !group.collapsed }">
        <div #elementKn (click)="onGroupeClick(group, elementKn )"
          [ngClass]="{ 'leftbar-group-item': group.items.length !== 0  }" class="d-flex align-items-center">
          <h6 *ngIf="group.badge" class="menu-badge"></h6>
          <img src="assets/images/icons/{{ group.icon }}" />
          <span>
            {{ group.name | translate }}
          </span>
        </div>
        <ul
          *ngIf="(((isCollapsed$ | async) === false && !navbarGroup.length) || (isCollapsedKnowladge$ | async) === false && navbarGroup.length) && !group.collapsed"
          class="leftbar-items">
          <ng-container *ngFor="let item of group.items">
            <li *ngIf="item.visible">
              <h6 *ngIf="item.badge" class="menu-badge"></h6>
              <a href="javascript:void(0)" routerLinkActive="active" [routerLink]="item.routerLink"
                [routerLinkActiveOptions]="{ exact: true }">{{ item.name | translate }}</a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>

  <div class="toggle-navbar-button" (click)="toggleSideBar()">
    <span class="k-icon k-i-arrow-chevron-left"></span>
  </div>
</aside>

<div
  *ngIf="selectedGroup && ((!navbarGroup.length && isCollapsed$ | async)||(navbarGroup.length && isCollapsedKnowladge$ | async))"
  [ngStyle]="{ top: selectedGroup.top + 'px' }" class="collapsed-navbar-wrapper">
  <ul class="leftbar-items">
    <ng-container *ngFor="let item of selectedGroup.items">
      <li *ngIf="item.visible">
        <a href="javascript:void(0)" [routerLink]="item.routerLink">{{
          item.name | translate
        }}</a>
      </li>
    </ng-container>
  </ul>
</div>
